import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const AuthActions = createActionGroup({
  source: 'Auth',
  events: {
    "Initialize Start": emptyProps(),
    "Initialize End": emptyProps(),


    "Initialize Auth Success": emptyProps(),
    "Initialize Auth Failure": props<{ error: string }>(),

    "Login Success": emptyProps(),
    "Login Error": props<{error: string}>(),
    "Redirect Start": emptyProps(),
    "Redirect End": emptyProps(),
    "Set Active Account Success": props<{ account: any }>(),
    "Set Active Account Failure": props<{ error: string }>(),

    "Get Azure Token Success": props<{ token: string }>(),
    "Get Azure Token Failure": props<{ error: string }>(),



    "Logout Success": emptyProps(),
    "Logout Failure": props<{ error: string }>(),
  }
});
